import { Icon } from '../../components/ui/Icon';
import type { PinnedItem, Suite } from '../../data/types/platform';

export interface PinnedStripProps {
  pinned: PinnedItem[];
  suites: Suite[];
  goToSystem: (systemId: string, moduleId?: string) => void;
}

export function PinnedStrip({ pinned, suites, goToSystem }: PinnedStripProps) {
  return (
    <section className="pinned-strip">
      <div className="ps-head">
        <h2>תיוקים</h2>
        <span className="ps-meta">{pinned.length} / 12 · מותאם אישית</span>
      </div>
      <div className="pinned-grid">
        {pinned.map((p, i) => {
          const suite = suites.find((x) => x.id === p.suite);
          const isUp = p.delta?.includes('+');
          return (
            <div className="pinned-card" key={i} onClick={() => goToSystem(p.suite, p.module)}>
              <span className="pc-pin"><Icon name="pin" size={12} /></span>
              <div className="pc-suite">
                <Icon name={suite?.icon} size={12} />
                {suite?.he}
              </div>
              <div className="pc-name">{p.he}</div>
              <div className="pc-metric">
                {p.metric}
                <span className={'pc-delta ' + (isUp ? 'up' : 'down')}>{p.delta}</span>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
